import { memo, ReactNode, CSSProperties } from 'react';
import classnames from 'classnames';

import { Icon } from '../icon';
import { CloseButton } from '../button';

import styles from './toast.module.scss';

export type AddToastFn = (toast: ToastData) => void;

export interface ToastData {
  kind: 'success' | 'error' | 'info';
  title: string;
  icon?: ReactNode;
  content: (removeToast: () => void) => ReactNode;
}

export interface ToastState extends ToastData {
  id: string;
  toastedAt: Date;
  isExiting: boolean;
}

interface ToastProps extends ToastState {
  idx: number;
  stackLength: number;
  style: CSSProperties;
  onRemove: (id: string) => void;
  onExpand: () => void;
}

export const Toast = memo(function Toast({
  id,
  idx,
  kind,
  isExiting,
  stackLength,
  onRemove,
  onExpand,
  title,
  icon,
  content,
  style,
  toastedAt,
}: ToastProps) {
  return (
    <div
      key={id}
      style={style}
      data-time={toastedAt}
      className={classnames(styles.toast, {
        [styles.toastSuccess]: kind === 'success',
        [styles.toastError]: kind === 'error',
        [styles.toastInfo]: kind === 'info',
        [styles.toastExit]: isExiting,
      })}
      onMouseEnter={() => idx === stackLength - 1 && onExpand()}>
      {icon ?? <Icon name={kind === 'error' ? 'Info' : 'CheckCircle'} className={styles.icon} />}
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.body}>{content(() => onRemove(id))}</div>
      </div>
      <CloseButton iconSize="regular" className={styles.closeButton} onClick={() => onRemove(id)} />
    </div>
  );
});
